var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.395,
    height: 18,
    viewBox: "0 0 18.395 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone",
    transform: "translate(0.352)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_320",
    "data-name": "Rectangle 320",
    width: 18,
    height: 18,
    transform: "translate(-0.352)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M10.472,12.857l1.933-1.768a.593.593,0,0,1,.483-.161l.322.161,4.511,2.089c.322.161.322.321.322.643a4.07,4.07,0,0,1-1.289,2.893A4.621,4.621,0,0,1,13.372,18a9.836,9.836,0,0,1-4.511-1.125A21.119,21.119,0,0,1,4.35,13.661a27.371,27.371,0,0,1-2.417-3.536A22.189,22.189,0,0,1,.322,6.589,9.867,9.867,0,0,1,0,3.536,4.219,4.219,0,0,1,1.128,1.125,4.906,4.906,0,0,1,4.189,0a.838.838,0,0,1,.644.321l2.417,4.5a.561.561,0,0,0,.161.321.589.589,0,0,1-.161.482L5.155,7.554a.716.716,0,0,0,0,.8,15.35,15.35,0,0,0,1.933,2.571,16.259,16.259,0,0,0,2.578,2.089C9.989,13.179,10.311,13.179,10.472,12.857Z",
    transform: "translate(0 0)",
    fill: "#004987"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0fc8f98ca13b1f9c15c554f3189dcd95.svg";
export { ForwardRef as ReactComponent };